import React, { useState } from 'react';

export default function LoginForm({ onAuth }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');

  const submit = e => {
    e.preventDefault();
    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user, pass })
    })
      .then(r => {
        if (!r.ok) throw new Error('Bad creds');
        return r.json();
      })
      .then(data => onAuth(data.token))
      .catch(() => alert('Invalid username or password'));
  };

  return (
    <form onSubmit={submit} style={{ padding: 20 }}>
      <h2 style={{ color: '#e1d6c0' }}>Admin Login</h2>
      <div>
        <input
          placeholder="Username"
          value={user}
          onChange={e => setUser(e.target.value)}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <input
          type="password"
          placeholder="Password"
          value={pass}
          onChange={e => setPass(e.target.value)}
        />
      </div>
      <button type="submit" style={{ marginTop: 12 }}>Log In</button>
    </form>
  );
}
